"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var uuid_1 = require("uuid");
exports.default = vue_1.default.extend({
    props: {
        initValue: {
            type: String,
            default: ""
        },
        id: {
            type: String,
            default: uuid_1.v4()
        }
    },
    data: function () {
        return {
            name: "registration-number-input",
            value: this.initValue
        };
    },
    methods: {
        isValid: function (emitValidation) {
            if (emitValidation === void 0) { emitValidation = false; }
            if (/([A-Z]{2})([0-9]{9})/.test(this.value)) {
                return true;
            }
            if (emitValidation) {
                this.$emit("invalid");
            }
            return false;
        },
        onInput: function (value) {
            this.value = value.toUpperCase();
            this.$emit("input", this.value);
        },
        onBlur: function () {
            this.appendValidationClass();
        },
        appendValidationClass: function () {
            var ref = this.$refs.registrationNumber;
            if (!ref || !ref.classList) {
                return;
            }
            if (this.isValid()) {
                ref.classList.remove("is-invalid");
                ref.classList.add("is-valid");
            }
            else {
                ref.classList.remove("is-valid");
                ref.classList.add("is-invalid");
            }
        }
    }
});
